import pdfMake from "pdfmake/build/pdfmake";
import headerPortraitImage from '../../assets/header-portrait.png';
import footerPortraitImage from '../../assets/footer-portrait.png';
import headerLandscapeImage from '../../assets/header-landscape.png';
import footerLandscapeImage from '../../assets/footer-landscape.png';

    function getItemTitle(item) {
        return `${item?.fname ?? ''} ${item?.mname ? item?.mname[0] + '.' : ''} ${item?.lname ?? ''}${item?.suffix ? ' ' + item?.suffix : ''}${item?.post_nominal ? ', ' + item?.post_nominal : ''}`;
    }

    async function getBase64Image(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = url;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/png')); // Convert to Base64
            };
            img.onerror = error => reject(error);
        });
    }

    export async function printLastPage( pageSize, pageMargins, pageOrientation, complianceData, officeName ) {
        // Smart width calculation for prepared by
        function getPreparedByWidths(count) {
            if (count <= 2) return [300];
            if (count === 3) return [400];
            return ['*'];
        }

        var headerImageBase64 = null
        var footerImageBase64 = null

        if(pageOrientation == 'landscape'){
            headerImageBase64 = await getBase64Image(headerLandscapeImage);
            footerImageBase64 = await getBase64Image(footerLandscapeImage);
        }
        else if(pageOrientation == 'portrait'){
            headerImageBase64 = await getBase64Image(headerPortraitImage);
            footerImageBase64 = await getBase64Image(footerPortraitImage);
        }

        function getAllCapsName(user) {
            let name = getItemTitle(user);
            return name ? name.toUpperCase() : '';
        }

        let preparedByRow = [];
        if (Array.isArray(complianceData.sameFileUsers)) {
            preparedByRow = complianceData.sameFileUsers.map((user, idx) => {
                return {
                    stack: [
                        user.esign ? {
                            image: "data:image/png;base64," + user.esign,
                            width: 60,
                            height: 40,
                            alignment: 'left',
                            margin: [0, 0, 0, -10]
                        } : {},
                        { text: getAllCapsName(user), bold: true, margin: [0, 0, 0, 0] },
                    ],
                    alignment: 'left',
                    margin: [idx === 0 ? 0 : 0, 0, 0, 0]
                };
            });
        }

        let docDefinition = {
            defaultStyle: {
                font: "ArialNarrow"
            },
            info: {
                title: 'Last Page for ' + complianceData.compliance.compliance_name,
            },
            pageSize: pageSize,
            pageOrientation: pageOrientation,
            pageMargins: pageMargins,
            header: (currentPage, pageCount, pageSize) => {
                return {
                    stack: [
                        {
                            image: headerImageBase64,
                            width: pageSize.width - 40,
                            alignment: 'center',
                            margin: [0, 8, 0, 0]
                        },
                        {
                            text: officeName,
                            fontSize: 16,
                            bold: true,
                            alignment: 'center',
                            font: "CenturySchoolBook"
                        }
                    ]
                };
            },
            footer: (currentPage, pageCount, pageSize) => ({
                image: footerImageBase64,
                width: pageSize.width - 40,
                alignment: 'center',
                margin: [0, 0, 0, 0]
            }),
            content: [
                {
                    layout: 'noBorders',
                    style: 'esign',
                    table: {
                        widths: getPreparedByWidths(preparedByRow.length),
                        body: [
                            [
                                {
                                    stack: [
                                        { text: 'Prepared by:', margin: [0, 0, 0, -5] },
                                        {
                                            columns: preparedByRow,
                                            columnGap: 5,
                                        }
                                    ],
                                    alignment: 'left',
                                    margin: [-20, 0, 20, 0]
                                }
                            ]
                        ]
                    }
                },
                { text: '', margin: [0, 20, 0, 0] },
                {
                    layout: 'noBorders',
                    style: 'esign',
                    table: {
                        widths: ['*', '*'],
                        body: [
                            [
                                {
                                    stack: [
                                        { text: 'Reviewed by:', margin: [0, 15, 0, -5] },
                                        {
                                            image: "data:image/png;base64," + complianceData.file.reviewer_esign?.b64_name,
                                            width: 60,
                                            height: 40,
                                            alignment: 'left',
                                            margin: [0, 0, 0, -10]
                                        },
                                        { text: getAllCapsName(complianceData.file.reviewer), bold: true },
                                        { text: complianceData.file.reviewer.designation }
                                    ],
                                    alignment: 'left',
                                    margin: [-20, 0, 0, 0]
                                },
                                {
                                    stack: [
                                        { text: 'Approved by:', margin: [0, 15, 0, -5] },
                                        {
                                            image: "data:image/png;base64," + complianceData.file.approver_esign?.b64_name,
                                            width: 60,
                                            height: 40,
                                            alignment: 'left',
                                            margin: [0, 0, 0, -10]
                                        },
                                        { text: getAllCapsName(complianceData.file.approver), bold: true },
                                        { text: complianceData.file.approver.designation }
                                    ],
                                    alignment: 'left',
                                    margin: [-20, 0, 0, 0]
                                }
                            ]
                        ]
                    }
                },
                {
                layout: 'noBorders',
                style: 'remarks',
                table: {
                    widths: ['*'],
                    body: [
                    [
                        {
                        stack: [
                            {
                            text: 'Revision Logs:',
                            margin: [0, 0, 0, 10],
                            bold: true
                            },
                            ...complianceData.file.remarks.map(r => {
                            const checklist = r.details
                                .split('\n')
                                .filter(line => line.trim().startsWith('•'));

                            const remarkStack = [];

                            remarkStack.push({
                                text: r.details.split('\n')[0],
                                bold: true,
                                margin: [0, 0, 0, checklist.length ? 5 : 2],
                            });

                            if (checklist.length) {
                                remarkStack.push({
                                ul: checklist,
                                margin: [0, 0, 0, 5],
                                });
                            }

                            if (r.remarks) {
                                remarkStack.push(
                                { text: 'Remark:', bold: true },
                                {
                                    text: r.remarks,
                                    italics: true,
                                    margin: [10, 0, 0, 5],
                                }
                                );
                            }

                            remarkStack.push({
                                text: `- ${r.createdBy?.fname} ${r.createdBy.lname}`,
                                alignment: 'left',
                                italics: true,
                                fontSize: 8,
                                margin: [0, 3, 0, 10],
                            });

                            return {
                                stack: remarkStack,
                                margin: [0, 0, 0, 5]
                            };
                            })
                        ],
                        alignment: 'left',
                        margin: [-20, 0, 0, 0]
                        }
                    ]
                    ]
                }
                }
            ],

            styles: {
                esign: {
                    fontSize: 10,
                    margin: [70, 0, 0, 0]
                },
                remarks: {
                    fontSize: 9,
                    margin: [20, 30, 0, 0]
                }
            }
        }

        pdfMake.createPdf(docDefinition).open();
    }